// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"91":"493ee4694a09af52d2b9","688":"47587a76baaaad948933","700":"e94fd7801a14350d96b5","753":"f97e671516506e7606f7","864":"bfe0a764cf87eb44fe98","938":"39f6e63487540b41e138","978":"b2bf2380886c7a245943"}[chunkId] + ".js";
};